<template>
	<div class="mt-4 mb-5">
		<!-- Basic Details - Start -->
		<div class="row">
			<div class="col-12 pr-5 pl-5 mt-4">
				<h5>Clear opcache</h5>
				<p>
					OPcache stores frequently used PHP code in memory so it can be accessed faster.
				</p>
				<p>When to flush OPcache:</p>
				<ul>
					<li>If your site is stuck in maintenance mode.</li>
					<li>If you've recently made any modifications to a PHP script directly, example via FTP.</li>
				</ul>
				<div class="col-12 mb-2 text-right">
					<button :disabled="loading" @click.prevent="flushOPcache" class="btn btn-outline-primary btn-round btn-sm btn-primary mr-3" v-if="account.flushOpcacheURL !== ''">
						<div class="loader small_loader" v-if="loading && type === 'flush-opcache'"></div>
						<span v-else>
							Clear opcache
						</span>
					</button>
				</div>
				<hr />
			</div>
			<div class="col-12 pr-5 pl-5 mt-4">
				<h5>Clear page cache</h5>
				<p>Page cache takes a 'snapshot' of each one of your pages and stores them as a compressed HTML file,
					this allows the page to be served to the visitor much faster since you do not have to rely on PHP to
					dynamically generate the entire page.</p>
				<p>When to flush page cache:</p>
				<ul>
					<li>Visual changes to your site are not appearing.</li>
				</ul>
				<div class="col-12 mb-2 text-right">
					<button :disabled="loading" @click.prevent="flushPageCache" class="btn btn-outline-primary btn-round btn-sm btn-primary mr-3">
						<div class="loader small_loader" v-if="loading && type === 'page-cache'"></div>
						<span v-else>
							Clear page cache
						</span>
					</button>
				</div>
				<hr />
			</div>
			<div class="col-12 pr-5 pl-5 mt-4">
				<h5>Clear object cache</h5>
				<p>Object cache stores the data from frequently used database queries in memory to reduce
					the time it takes to pull that data each time its requested.</p>
				<p>When to flush object cache:</p>
				<ul>
					<li>If you notice saving a setting will not save, or reverts to the previous saved option.</li>
				</ul>
				<div class="col-12 mb-2 text-right">
					<button :disabled="loading" @click.prevent="flushObjectCache" class="btn btn-outline-primary btn-round btn-sm btn-primary mr-3">
						<div class="loader small_loader" v-if="loading && type === 'page-object'"></div>
						<span v-else>
							Clear object cache
						</span>
					</button>
				</div>
				<hr />
			</div>
			<div class="col-12 pr-5 pl-5 mt-4">
				<h5>Clear ALL cache</h5>
				<p>Clears all server side cache: opcache, page cache, object cache. </p>
				<div class="col-12 mb-2 text-right">
					<button :disabled="loading" @click.prevent="flushAllCache" class="btn btn-outline-primary btn-round btn-sm btn-primary mr-3">
						<div class="loader small_loader" v-if="loading && type === 'page-all'"></div>
						<span v-else>
							Clear ALL Server Cache
						</span>
					</button>
				</div>
				<hr />
			</div>
			<div class="col-12 pr-5 pl-5 mt-4">
				<h5>Flush Cloudflare cache</h5>
				<p>You can purge your cached resources using either the Caching app in the Cloudflare</p>
				<div class="col-12 mb-2 text-right">
					<button :disabled="loading" @click.prevent="flushCloudflareCache" class="btn btn-outline-primary btn-round btn-sm btn-primary mr-3">
						<div class="loader small_loader" v-if="loading && type === 'cloudflare'"></div>
						<span v-else>
							Clear cloudflare cache
						</span>
					</button>
				</div>
				<hr />
			</div>
		</div>
	</div>
</template>

<script>
	import swal from "sweetalert2";
	import axios from "axios";
	import _ from "lodash";
	import refreshToken from "../../../../mixins/refreshTokenMixin";

	export default {
		name: "Cache",
		mixins: [refreshToken],
		props: {
			account: {
				type: Object,
				required: true
			}
		},
		data: function () {
			return {
				loading: false,
				type: null
			}
		},
		computed: {
			userToken() {
				return this.$store.getters.getUserToken;
			}
		},
		beforeMount() {

		},
		methods: {
			flushPageCache() {
				swal({
					title: "Are you sure?",
					text: `Please confirm that you would like to clear page cache.`,
					type: "question",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				})
					.then(result => {
						if (result.value) {
							this.loading = true;
							this.type = 'page-cache';

							this.$http.post('cache/page', {
								ip: this.account.ftp.host,
								grant_type: "token",
								domain: this.account.domain,
								token: this.userToken,
							}, {
								headers: {
									'Content-Type': 'application/json'
								}
							})
								.then(() => {
									swal({
										title: "Success!",
										html: "Page cache was cleared",
										type: "success"
									})
								})
								.catch(() => {
									swal({
										title: "Error!",
										html: "Error clearing page cache",
										type: "error"
									})
								})
								.finally(() => {
									this.loading = false;
									this.type = null;
								});
						}
					});
			},
			flushObjectCache() {
				swal({
					title: "Are you sure?",
					text: `Please confirm that you would like to clear object cache.`,
					type: "question",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				})
					.then(result => {
						if (result.value) {
							this.loading = true;
							this.type = 'page-object';

							this.$http.post('cache/object', {
								ip: this.account.ftp.host,
								grant_type: "token",
								domain: this.account.domain,
								token: this.userToken,
							}, {
								headers: {
									'Content-Type': 'application/json'
								}
							})
								.then(() => {
									swal({
										title: "Success!",
										html: "Object cache was cleaned",
										type: "success"
									})
								})
								.catch(() => {
									swal({
										title: "Error!",
										html: "Error clearing object cache",
										type: "error"
									})
								})
								.finally(() => {
									this.loading = false;
									this.type = null;
								});
						}
					});
			},
			flushAllCache() {
				swal({
					title: "Are you sure?",
					text: `Please confirm that you would like to clear all cache.`,
					type: "question",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				})
					.then(result => {
						if (result.value) {
							this.loading = true;
							this.type = 'page-all';

							this.$http.post('cache/all', {
								ip: this.account.ftp.host,
								url: this.account.flushOpcacheURL,
								domain: this.account.domain,
								grant_type: "token",
								token: this.userToken,
							}, {
								headers: {
									'Content-Type': 'application/json'
								}
							})
								.then(() => {
									swal({
										title: "Success!",
										html: "All cache was cleaned",
										type: "success"
									})
								})
								.catch(() => {
									swal({
										title: "Error!",
										html: "Error clearing all cache",
										type: "error"
									})
								})
								.finally(() => {
									this.loading = false;
									this.type = null;
								});
						}
					});
			},
			flushOPcache() {
				swal({
					title: "Are you sure?",
					text: `Please confirm that you would like to flush OPcache.`,
					type: "question",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				})
					.then(result => {
						if (result.value) {
							this.loading = true;
							this.type = 'flush-opcache';
							axios.get(this.account.flushOpcacheURL)
								.finally(() => {
									this.loading = false;
									this.type = null;
									swal({
										title: "Success!",
										html: "OPcache was flushed",
										type: "success"
									})
								})
						}
					})
			},
			flushCloudflareCache() {
				swal({
					title: "Are you sure?",
					text: `Please confirm that you would like to flush Cloudflare.`,
					type: "question",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				})
					.then(result => {
						if (result.value) {
							this.loading = true;
							this.type = 'cloudflare';

							this.$http.post("dns/purge-cache", {
								grant_type: "token",
								token: this.userToken,
								tier: this.account.cloudflarePlan || 'free',
								domain: this.account.domain,
								cloudflare_email: this.account.cloudflare.username,
								cloudflare_api_key: this.account.cloudflare.apiKey,
								cloudflare_zone: this.account.cloudflare.zone_id,
							})
								.then(() => {
									swal({
										title: "Success!",
										html: "Cloudflare was flushed",
										type: "success"
									})
								})
								.catch((err) => {
									let responseMessage = err.response.data.message;
									if (err.response.status === 422) {
										responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
									}else if(err.response.status === 401){
										responseMessage = "You need update token. Please Try Again!";
										this.refreshToken();
									}

									swal({
										title: "Something went wrong!",
										html: responseMessage,
										type: "error",
										confirmButtonText: "Try Again!",
										confirmButtonColor: "#EE8057"
									});
									this.addLog({
										name: this.account.domain,
										message: "Error flush Cloudflare. Message: " + responseMessage,
										level: "danger"
									});
								})
								.finally(() => {
									this.loading = false;
									this.type = null;
								});
						}
					})
			}
		}
	};
</script>
